import {
  NotificationQuestErrorState,
  NotificationState,
} from "@/domains/notification/constants/notificationState";

export default function isQuestErrorNotification(
  notification: NotificationState,
): notification is NotificationQuestErrorState {
  return (notification as NotificationQuestErrorState).rewards !== undefined;
}
